import React, { useRef, useState, useEffect, useCallback } from 'react';
import styled from 'styled-components';
import palette from '../../../lib/styles/palette';

import { MdExpandMore, MdExpandLess, MdRemoveCircleOutline, MdAdd } from 'react-icons/md';
// import ActionButtons from '../ActionButtons';
// import AskCancelModal from '../AskCancelModal';

import { standardWeight_Shuttle } from '../../../lib/data/standard-weight';

const ShuttleForm = ({ onSaveStructure, onChangeWeightSummary, shuttles, beltWidth }) => {
    const [isShow, setIsShow] = useState(shuttles?.length || false);
    const [newShuttle, setNewShuttle] = useState(shuttles || []);
    const [factor, setFactor] = useState('1.0');
    const [id, setId] = useState('');
    const [lengthCategory, setLengthCategory] = useState('');
    const [length, setLength] = useState('');
    const [standardWeight, setStandardWeight] = useState('');
    const [qty, setQty] = useState('');
    const [unitWeight, setUnitWeight] = useState('');
    const [weight, setWeight] = useState('');
    const [totalQty, setTotalQty] = useState('');
    const [totalWeight, setTotalWeight] = useState('');
    // const [modal, setModal] = useState(false);
    /* 변경사항을 저장했었는지 여부에 대한 상태 저장 */
    const [isChanged, setIsChanged] = useState(false);

    /* standard weight library에서 해당 벨트폭을 뽑아서 저장한다. */
    // const [weightLibrary, setWeightLibrary] = useState('');
    const weightLibrary = useRef(null); // chatGPT가 알려준 내용

    /* category 설명하는 text */
    const lengthCategoryText = useRef({
        0: '10m 이하',
        1: '10m 초과 20m 이하',
        2: '20m 초과',
    });

    /*  처음 props로 넘어온 shuttles를 초기값 그대로 보관하고 있다가 취소 버튼을 눌렀을 때 원상 복귀 시키기 위해
        useRef를 사용하여 저장해 둔다. */
    // const initialShuttle = useRef(shuttles ? shuttles : []);
    // const initialShuttle = useRef(shuttles || []);

    /* 벨트폭에 해당하는 Weight Table을 가져온다. */
    useEffect(() => {
        if (!standardWeight_Shuttle || !beltWidth) return;
        const library = standardWeight_Shuttle.find((item) => item.beltWidth === parseInt(beltWidth));
        if (!library) {
            alert('Check Belt Width!!');
            return;
        }
        weightLibrary.current = library;
    }, [beltWidth]);

    /* 기준 중량 가져오기 함수 */
    const getStandardWeight = useCallback((length) => {
        if (!weightLibrary.current) return;

        const lengthCategory = length < 10 ? 0 : length < 20 ? 1 : 2;
        setLengthCategory(lengthCategory);

        return weightLibrary.current.standardWeight[lengthCategory];
    }, []);

    /* 기준 중량 가져오기, 단위 중량 계산하기 */
    useEffect(() => {
        if (!length) return;
        const _standardWeight = getStandardWeight(Number(length));
        const _unitWeight = Math.ceil(_standardWeight * factor);
        setStandardWeight(_standardWeight);
        setUnitWeight(_unitWeight);
    }, [factor, getStandardWeight, length]);

    /* 중량 계산 */
    useEffect(() => {
        // if (!qty || !unitWeight) return;
        const _weight = Math.ceil(unitWeight * qty);
        setWeight(_weight);
    }, [qty, unitWeight]);

    /* 마지막 shuttle ID 가져오기 함수 */
    const getLastId = useCallback(() => {
        if (!newShuttle.length) {
            return 0;
        }
        /*
        const lastshuttle = newShuttle.reduce((accumulator, currentValue) => {
            const currentId = currentValue.id.substring(3);
            const accumulatorId = accumulator.id.substring(3);
            if (currentId> accumulatorId) {
                return currentValue;
            }
            return accumulator;
        });
        return lastshuttle.id.substring(3);
        */
        /* ChatGPT가 알려준 함수. 한줄로 정리가 되네....ㅋ */
        return Math.max(...newShuttle.map((shuttle) => Number(shuttle.id.substring(3))), 0);
    }, [newShuttle]);

    /* 입력 후 폼 초기화 함수 */
    const initializeForm = useCallback(() => {
        setId(`SH-${getLastId() * 1 + 1}`);
        setLengthCategory('');
        setLength('');
        setStandardWeight('');
        // setFactor('');
        setQty('');
        setUnitWeight('');
        setWeight('');
    }, [getLastId]);

    /* 전체 수량 계산 함수 */
    const getTotalQty = useCallback((shuttles) => {
        const total = shuttles.reduce((accumulator, currentValue) => {
            return accumulator + parseInt(currentValue.qty);
        }, 0);
        setTotalQty(total);
    }, []);

    /* 전체 중량 계산 함수 */
    const getTotalWeight = useCallback((shuttles) => {
        const total = shuttles.reduce((accumulator, currentValue) => {
            return accumulator + currentValue.weight;
        }, 0);
        setTotalWeight(total);
    }, []);

    /* 추가 버튼을 누르면 newShuttle에 shuttle 추가 */
    const onAddShuttle = useCallback(() => {
        if (!qty || !unitWeight || !weight) {
            alert('Check input(s) before saving!!!');
            return;
        }
        const shuttle = {
            id,
            lengthCategory: lengthCategoryText.current[`${lengthCategory}`],
            length,
            standardWeight,
            factor,
            qty,
            unitWeight,
            weight,
        };
        setNewShuttle((prev) => [...prev, shuttle]);
        setIsChanged(true);
    }, [factor, id, qty, length, lengthCategory, standardWeight, unitWeight, weight]);

    /* 삭제 버튼을 누르면 해당 shuttle 삭제 */
    const onDeleteshuttle = useCallback((id) => {
        // setNewShuttle(newShuttle.filter(shuttle => shuttle.id !== id));
        // chatGPT가 알려준 방법. 이렇게 해야 newShuttle를 의존성 배열에서 없앨 수 있다.
        setNewShuttle((prev) => prev.filter((shuttle) => shuttle.id !== id));
        setIsChanged(true);
    }, []);

    /* newShuttle에 변화가 생기면 리덕스에 변경사항 쓰기 */
    useEffect(() => {
        /* 이 부분이 onAddShuttle 함수안으로 들어가면 제대로 작동하지 않음. */
        getTotalQty(newShuttle);
        getTotalWeight(newShuttle);
        initializeForm();
        /* 여기까지 */

        onSaveStructure({
            key: 'shuttle',
            value: newShuttle,
        });
        onChangeWeightSummary({
            key: 'shuttle',
            // value: getTotalWeight(),
            value: {
                totalQty,
                totalWeight,
            },
        });
        // setIsChanged(true);
    }, [
        getTotalQty,
        getTotalWeight,
        initializeForm,
        newShuttle,
        onChangeWeightSummary,
        onSaveStructure,
        totalQty,
        totalWeight,
    ]);

    /* Save 버튼을 누르면 리덕스에 변경사항 쓰기 */
    // const onSaveshuttle = useCallback(() => {
    //     setNewShuttle(initialShuttle.current);
    //     onSaveStructure({
    //         key: 'shuttle',
    //         value: newShuttle,
    //     });
    //     onChangeWeightSummary({
    //         key: 'shuttle',
    //         // value: getTotalWeight(),
    //         value: {
    //             totalQty,
    //             totalWeight,
    //         },
    //     });
    // }, [newShuttle, onChangeWeightSummary, onSaveStructure, totalQty, totalWeight]);

    /* 변경 사항을 취소하면 newShuttle를 초기값으로 변경하고 리덕스에 초기값으로 쓰기 */
    // const onCancelChange = useCallback(() => {
    //     setNewShuttle(initialShuttle.current);
    //     onSaveStructure({
    //         key: 'shuttle',
    //         // value: newShuttle,
    //         value: initialShuttle.current, // chatGPT가 알려준 방법. 이렇게 해야 newShuttle를 의존성배열에서 삭제할 수 있다.
    //     });
    //     onChangeWeightSummary({
    //         key: 'shuttle',
    //         value: {},
    //     });
    //     setModal(false);
    // }, [onChangeWeightSummary, onSaveStructure]);

    /* Cancel Change 버튼을 눌렀을 때 */
    // const onClickCancel = useCallback(() => {
    //     // 저장된 적이 없다면 alert
    //     if (!isChanged) {
    //         alert('변경내용이 없습니다.');
    //         return;
    //     }
    //     setModal(true);
    // }, [isChanged]);

    return (
        <ShuttleFormBlock>
            <Title>
                <h3 style={{ width: '400px', margin: '0' }}>Shuttle</h3>
                <div style={{ width: '120px' }}>Q'ty: {totalQty} ea</div>
                <div style={{ width: '170px' }}>Weight: {totalWeight} kg</div>
                <div style={{ fontSize: '1.25rem', fontWeight: 'bold', display: 'flex', alignItems: 'flex-end' }}>
                    {!isShow ? (
                        <MdExpandMore color="orange" onClick={() => setIsShow(true)} />
                    ) : (
                        <MdExpandLess color="orange" onClick={() => setIsShow(false)} />
                    )}
                </div>
            </Title>
            {isShow && (
                <>
                    <table>
                        <thead>
                            <tr>
                                <th>ID.</th>
                                <th>
                                    Shuttle
                                    <br />
                                    Length
                                    <br />
                                    (m)
                                </th>
                                <th>Length Category</th>
                                <th>
                                    Standard W't <br />
                                    (kg/m)
                                </th>
                                <th>Factor</th>
                                <th>
                                    Unit W't <br />
                                    (kg/set)
                                </th>
                                <th>Q'ty</th>
                                <th>중량(kg)</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {newShuttle &&
                                newShuttle.map((shuttle, index) => (
                                    <tr key={index}>
                                        <td className="id">{shuttle.id}</td>
                                        <td className="span">{shuttle.length}</td>
                                        <td className="length-category">{shuttle.lengthCategory}</td>
                                        <td className="s-weight">{shuttle.standardWeight}</td>
                                        <td className="factor">{shuttle.factor}</td>
                                        <td>{shuttle.unitWeight}</td>
                                        <td className="qty">{shuttle.qty}</td>
                                        <td>{shuttle.weight}</td>
                                        <td className="btn-delete" onClick={() => onDeleteshuttle(shuttle.id)}>
                                            <MdRemoveCircleOutline />
                                        </td>
                                    </tr>
                                ))}
                            <tr>
                                <td></td>
                            </tr>{' '}
                            {/* 행 사이의 간격을 띄우기 위해 */}
                            <tr>
                                <td></td>
                            </tr>{' '}
                            {/* 행 사이의 간격을 띄우기 위해 */}
                            <tr className="input-form">
                                <td className="id-column">{id}</td>
                                <td>
                                    <StyledInput
                                        placeholder="..."
                                        value={length}
                                        onChange={(e) => setLength(e.target.value)}
                                    />
                                </td>
                                <td>{lengthCategoryText.current[lengthCategory]}</td>
                                <td>
                                    <StyledInput
                                        placeholder="..."
                                        value={standardWeight}
                                        onChange={(e) => setStandardWeight(e.target.value)}
                                    />
                                </td>
                                <td>
                                    <StyledInput
                                        placeholder="..."
                                        value={factor}
                                        onChange={(e) => setFactor(e.target.value)}
                                    />
                                </td>
                                <td>{unitWeight}</td>
                                <td>
                                    <StyledInput
                                        placeholder="..."
                                        value={qty}
                                        onChange={(e) => setQty(e.target.value)}
                                    />
                                </td>
                                <td className="total-weight">{weight}</td>
                                <td className="btn-add" onClick={onAddShuttle}>
                                    <MdAdd />
                                </td>
                            </tr>
                        </tbody>
                        <tfoot>
                            <tr>
                                <td colSpan={5}>Shuttle Frame Total</td>
                                <td></td>
                                <td>{totalQty}</td>
                                <td>{totalWeight}</td>
                            </tr>
                        </tfoot>
                    </table>
                    {/* <ActionButtons confirmText="Save" cancelText="Cancel Change" onConfirm={onSaveshuttle} onCancel={onClickCancel} /> */}
                    {/* <AskCancelModal visible={modal} onConfirm={onCancelChange} onCancel={() => setModal(false)} /> */}
                </>
            )}
        </ShuttleFormBlock>
    );
};

export default ShuttleForm;

/* =================   Styles   ================== */
const Title = styled.div`
    display: flex;
    align-items: flex-end;
    margin-bottom: 1rem;

    color: ${palette.cyan[6]};
`;

const ShuttleFormBlock = styled.div`
    // max-width: 1280px;
    // margin: 0 auto;
    // margin: 0 2rem;
    .btn-delete {
        color: ${palette.cyan[6]};
        font-size: 1rem;
        cursor: pointer;
        padding: 0 1rem;
        padding-top: 0.3rem;
        &:hover {
            color: ${palette.cyan[4]};
        }
    }
    .btn-add {
        color: ${palette.cyan[6]};
        font-size: 1.5rem;
        cursor: pointer;
        padding: 0;
        padding-top: 0.4rem;
        &:hover {
            color: ${palette.cyan[4]};
        }
    }
    table {
        width: 100%; // 이 코드때문에 table이 꽉 차게 나오는 것임.
        font-size: 0.9rem;
        border-collapse: collapse;
    }
    thead {
        border-top: 1px solid ${palette.gray[4]};
        border-bottom: 1px solid ${palette.gray[4]};
        color: ${palette.gray[7]};
        // background-color: ${palette.gray[0]}
    }
    tfoot {
        border-top: 1px solid ${palette.gray[4]};
        border-bottom: 1px solid ${palette.gray[4]};
        height: 2.5rem;
        font-weight: bold;
        color: ${palette.gray[7]};
        // background-color: ${palette.gray[0]}
    }
    th {
        padding: 0.5rem 0.25rem;
        text-align: center;
    }
    td {
        padding: 0.25rem 0.25rem;
        text-align: center;
    }
    .input-radio {
        display: flex;
        flex-direction: column;
        margin: 0 auto;
        align-items: flex-start;
        length {
            margin-left: 0.5rem;
        }
        // 추가함
        label + label {
            margin-top: 0.25rem;
        }
    }
    h3 {
        color: ${palette.cyan[6]};
    }
    .input-form {
        background-color: ${palette.gray[0]};
    }
    .right-align {
        text-align: right;
    }
`;

const StyledInput = styled.input`
    border: none;
    outline: none;
    padding: 0.25rem 0.5rem;
    width: 50px;
    text-align: center;
    background: transparent;
    &:hover {
        background: ${palette.gray[3]};
    }
`;
